import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@kaizen/environment/environment';

export const urlInterceptor: HttpInterceptorFn = (req, next) => {
  const url = `${environment.api.url}/${req.url}`;

  const newReq = req.clone({ url });
  return next(newReq);
};
